import { IAuth } from '../state/actions/auth';
import { IStoreState } from '../state/store';

export const getAuth = ({ auth }: IStoreState): IAuth => auth;
